import PropTypes from 'prop-types'
import React from 'react'

import HowToBlock from 'components/_special/HowToBlock'
import SliderMobile from 'components/SliderMobile'

import { DynamicImageStyled, Wrapper } from './styles'

const SLIDER_DIR = 'unpackage'

/**
 * HowToOrderMobile - component of mobile first step's block
 *
 * @param {object} props - properties of component
 * @returns {node} HowToOrderMobile
 */
const HowToOrderMobile = props => {
  const {
    index,
    images,
    title,
    descriptions,
    pathCdn,
    isWhite,
    textColor,
    lineColor,
    squareColor,
  } = props
  const path = `${pathCdn}/${SLIDER_DIR}`

  return (
    <div className="pb-2">
      <HowToBlock
        title={title}
        index={index}
        squareColor={squareColor}
        isFirst={true}
        textColor={textColor}
        lineColor={lineColor}
      />
      <Wrapper>
        <SliderMobile {...{ isWhite, descriptions }} autoHeight={false}>
          {images.map((image, index) => (
            <div key={index}>
              <DynamicImageStyled
                alt={image}
                image={`${path}/${image}`}
                imageSizes={{ xs: 320 }}
                imageType="png"
                namesByBreakpoints
              />
            </div>
          ))}
        </SliderMobile>
      </Wrapper>
    </div>
  )
}

HowToOrderMobile.propTypes = {
  /** Array of descriptions for slider */
  descriptions: PropTypes.array.isRequired,

  /** Structure of images for slider (must be .png) */
  images: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,

  /** Index */
  index: PropTypes.number.isRequired,

  /** Path to a directory with page's files */
  pathCdn: PropTypes.string.isRequired,

  /** Title for block */
  title: PropTypes.string.isRequired,

  /** Square background color */
  squareColor: PropTypes.string.isRequired,

  /** Flag to set white color for controls */
  isWhite: PropTypes.bool,

  /** Line background color */
  lineColor: PropTypes.oneOf(['light', 'dark']),

  /** Text color */
  textColor: PropTypes.oneOf(['light', 'dark']),
}

HowToOrderMobile.defaultProps = {
  textColor: 'dark',
  lineColor: 'dark',
}

export default HowToOrderMobile
